export const buildInfo = {
    buildDate: "Thu, 10/07/2025",
    buildTime: "23:07:50",

    sourceTag: "release-202507-1-hotfix-2",
    sourceDate: "Thu, 10 Jul 2025 10:05:53 +0800",
    sourceBranch: "master",
    sourceHash: "1f7b8209b0186c07ce8e114de1f1fa44b97771ab",
};
